import { render } from "./CircleArrowDown.vue?vue&type=template&id=f8e6c0aa&scoped=true"
import script from "./CircleArrowDown.vue?vue&type=script&lang=js"
export * from "./CircleArrowDown.vue?vue&type=script&lang=js"

import "./CircleArrowDown.vue?vue&type=style&index=0&id=f8e6c0aa&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e6c0aa"]])

export default __exports__